import { COMMON, styled } from '@mentimeter/ragnar-styled';
import { cn } from '@mentimeter/ragnar-tailwind-config';
import { Content } from '@radix-ui/react-popover';
import type { ComponentProps } from 'react';
import * as React from 'react';

const PopoverContentRadixStyled = styled(
  Content,
  {
    displayName: 'PopoverContentRadixStyled',
  },
  true,
  [
    'forceMount',
    'side',
    'sideOffset',
    'align',
    'alignOffset',
    'avoidCollisions',
    'collisionBoundary',
    'collisionPadding',
    'arrowPadding',
    'sticky',
    'hideWhenDetached',
  ],
)(
  ...COMMON,
  'kosmosBorderRadius',
  'kosmosSpacing',
  'layout',
  'flexbox',
  'position',
);

export type PopoverContentProps = ComponentProps<
  typeof PopoverContentRadixStyled
>;

export const PopoverContent = React.forwardRef(
  ({ className, ...props }: PopoverContentProps, forwardedRef) => {
    const defaultClasses = [
      'flex',
      'flex-col',
      'items-stretch',
      'max-w-[calc(100vw-(--spacing(4)))]',
      'max-h-[calc(100vw-(--spacing(4)))]',
      'sm:max-w-[calc(100vw-2*(--spacing(16)))]',
      'sm:max-h-[calc(100vw-2*(--spacing(16)))]',
      'min-w-[200px]',
      'bg-surface-overlay',
      'rounded-lg',
      '[filter:drop-shadow(0px_0px_1px_var(--color-border))_drop-shadow(0_3px_15px_var(--palette-black-alpha-400))]',
      'z-modal',
      'focus:outline-none',
      'data-[side=bottom]:motion-safe:animate-fade-in-bottom',
      'data-[state=closed]:data-[side=bottom]:motion-safe:animate-fade-out-bottom',
      'data-[side=top]:motion-safe:animate-fade-in-top',
      'data-[state=closed]:data-[side=top]:motion-safe:animate-fade-out-top',
      'data-[side=left]:motion-safe:animate-fade-in-left',
      'data-[state=closed]:data-[side=left]:motion-safe:animate-fade-out-left',
      'data-[side=right]:motion-safe:animate-fade-in-right',
      'data-[state=closed]:data-[side=right]:motion-safe:animate-fade-out-right',
    ];
    return (
      <PopoverContentRadixStyled
        ref={forwardedRef}
        collisionPadding={16}
        arrowPadding={4}
        sideOffset={1}
        className={cn(defaultClasses, className)}
        aria-labelledby="ragnar-popover-title"
        {...props}
      />
    );
  },
);
